import classNames from 'classnames'
import { AnimatePresence, motion, Variants } from 'framer-motion'
import { ReactNode, useEffect, useState } from 'react'

import { VertSpacerLg } from '@apps-common/components/layout/spacers/VertSpacerLG'
import { commonIcons } from '@apps-common/config/icons'
import { motionFadeIn } from '@apps-common/config/motion-variants'

const variants: Variants = {
  initial: {
    height: 0,
    overflow: 'hidden',
    transition: {
      duration: 0.25
    }
  },
  animate: {
    height: 'auto',
    overflow: 'visible',
    transition: {
      duration: 0.25
    }
  }
}

const childVariants: Variants = {
  initial: {
    // position: 'absolute',
    opacity: 0,
    transition: {
      ease: 'easeInOut',
      duration: 0.25
    }
  },
  animate: {
    opacity: 1,
    // transitionEnd: {
    //   position: 'relative'
    // },
    transition: {
      delay: 0.1,
      ease: 'easeInOut',
      duration: 0.25
    }
  }
}

const PADDING_Y = 'py-[0.75rem]'
const PADDING_X = 'px-[0.75rem] sm:px-[1.25rem]'
const PADDING_T = 'pt-[0.5rem]'
const PADDING_B = 'pb-[0.5rem]'

interface IProps {
  key?: string
  defaultOpen: boolean
  disabled: boolean
  classes?: string
  title: string
  children: ReactNode
}

export const CollapsibleContent = ({ key, defaultOpen, disabled, classes, title, children }: IProps) => {
  const [open, setOpen] = useState<boolean>(defaultOpen)

  useEffect(() => {
    if (defaultOpen !== open) {
      setOpen(defaultOpen)
    }
  }, [defaultOpen])

  useEffect(() => {
    if (disabled) {
      setOpen(false)
    } else {
      setOpen(defaultOpen)
    }
  }, [disabled])

  return (
    <div className={classNames(classes, 'w-full overflow-hidden', disabled && 'opacity-80')}>
      <button
        type='button'
        className={classNames(
          PADDING_Y,
          PADDING_X,
          'w-full flex items-center justify-between outline-none bg-surface-2 text-text border-b border-border hover:!cursor-pointer'
        )}
        onClick={() => setOpen(!open)}
        disabled={disabled}
      >
        <h3 className='jost text-[0.9em]'>{title}</h3>
        <motion.div
          initial={false}
          animate={{
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: {
              // type: 'spring',
              // stiffness: 50,
              ease: 'easeInOut',
              duration: 0.2
            }
          }}
        >
          <commonIcons.chevronDownSharp className='text-[1.35rem]' />
        </motion.div>
      </button>
      <motion.div
        animate={open ? 'animate' : 'initial'}
        initial={false}
        variants={variants}
        className={classNames(PADDING_X, 'overflow-hidden')}
      >
        <motion.div
          initial={false}
          animate={open ? 'animate' : 'initial'}
          variants={childVariants}
          className={classNames(PADDING_B, 'overflow-hidden px-[4px]')}
        >
          <VertSpacerLg />
          <AnimatePresence>
            <motion.div key={`${key}-collapsible-content`} {...motionFadeIn(0.2)}>
              {children}
            </motion.div>
          </AnimatePresence>
        </motion.div>
      </motion.div>
    </div>
  )
}
